<script>
export const group = 'Full'
</script>

<script setup>
import DarioScheduledProgramsMedia from '../default/DarioScheduledProgramsMedia.vue'
import { ref, nextTick } from 'vue'
import Transition4 from './transitions/Transition4.vue'

defineProps({
  item: Object,
})

const transition = ref(null)

const startTransition = async () => {
  await nextTick()
  if (transition.value) {
    transition.value.start()
  }
}
</script>

<template>
  <Transition4 ref="transition" :manualStart="true">
    <DarioScheduledProgramsMedia class="bg-joe-cr-blue-darker" :item="item" @loaded="startTransition" />
  </Transition4>
</template>
